const mmRe = /([\d.]+)\s?mm/i;
const cmRe = /([\d.]+)\s?cm/i;
const inchRe = /([\d/ ]+)"/i;
const ltrRe = /([\d.]+)\s?(ltr|liter|litre)/i;

const regexes: Array<[RegExp, (val: string) => number]> = [
    [mmRe, (val) => +val],
    [cmRe, (val) => +val * 10],
    [ltrRe, (val) => +val * 1000],
    [
        inchRe,
        (val) => {
            const [numerator, denominator] = val.split('/');
            if (denominator != null) {
                const [part1, part2] = numerator.split(' ');
                if (part2) {
                    return +part1 + +part2 / +denominator;
                } else {
                    return +part1 / +denominator;
                }
            }
            return +val;
        },
    ],
];

/**
 * @description
 * Takes a product option name and attempts to convert it into a numeric value to be sorted.
 */
export function extractSizeValue(input: string): number {
    for (const [regex, fn] of regexes) {
        const matches = input.match(regex);
        if (matches && matches.length >= 2) {
            return fn(matches[1]);
        }
    }
    return Number.parseInt(input, 10) || 1;
}
